module.exports = __webpack_public_path__ + "static/media/logo.179db113.svg";